import { cn } from "@/lib/utils";

interface IconProps {
  className?: string;
}

/** Custom trust shield with G monogram — replaces ShieldCheck/Shield */
export function IconTrust({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("h-4 w-4", className)}
      aria-hidden="true"
    >
      {/* Shield shape — organic rounded */}
      <path d="M12 2L4 6V11C4 16.52 7.48 21.74 12 23C16.52 21.74 20 16.52 20 11V6L12 2Z" />
      {/* Inner checkmark */}
      <path d="M8 12L11 15L16 9" strokeWidth="2" />
    </svg>
  );
}
